// added by heliang 20240815 添加会员储值卡密
// 储值卡密
const name = '提货券'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/cardpassword',
  component: Layout,
  children: [
    {
      path: 'cardpassword',
      name: `提货券`,
      component: () => import( '@/view/member/cardpassword/list'),
      children: [
        {
          path: 'editor',
          component: () => import( '@/view/member/cardpassword/edit' )
        },
        // {
        //   path: 'detail',
        //   component: () => import( '@/view/member/cardpassword/detail')
        // }
      ]
    },
    {
      path: 'cardpassword_issue',
      name: `提货券发行`,
      component: () => import( '@/view/member/cardpassword/issue'),
    },
    {
      path: 'cardpassword_item',
      name: `提货券清单`,
      component: () => import( '@/view/member/cardpassword/item_list'),
    },
  ]
}
